import AuthService from 'src/services/auth.service.js';
import styles from 'src/legacy/pages/settings/dataSource/dataSourceView.module.scss';


const DATA_SOURCE_AUTH_BASE_URL = `http://localhost:8080/paperfliteApp/api/1.0/storage`;

const DropBoxIcon = '/images/dataSource/dropbox.png';
const BoxIcon = '/images/dataSource/box.png';
const GoogleDriveIcon = '/images/dataSource/gdrive.png';
const OneDriveIcon = '/images/dataSource/onedrive.png';
const SharePointIcon = '/images/dataSource/sharepoint.png';
const RssIcon = '/images/dataSource/rss.png';

export default class DataSourceService {
	constructor() {
		this.dataSources = [
			{
				id: 'dropbox',
				storageType: 'dropbox',
				name: 'Dropbox',
				icon: DropBoxIcon,
				class: styles.dropboximage
			},
			{
				id: 'gdrive',
				storageType: 'gdrive',
				name: 'Google Drive',
				icon: GoogleDriveIcon,
				class: styles.googledriveimage
			},
			{
				id: 'box',
				storageType: 'box',
				name: 'Box',
				icon: BoxIcon,
				class: styles.boximage
			},
			{
				id: 'onedrive',
				storageType: 'onedrive',
				name: 'OneDrive',
				icon: OneDriveIcon,
				class: styles.onedriveimage
			},
			{
				id: 'sharepoint',
				storageType: 'sharepoint',
				name: 'SharePoint',
				icon: SharePointIcon,
				class: styles.sharepointimage
			},
			{
				id: 'rss',
				storageType: 'rss',
				name: 'RSS Feed',
				icon: RssIcon,
				class: styles.rssimage
			}
		];
	}

	static isAuthenticate(sourceId, fetchDataSource) {

		var view = this;

		//Calculate Position
		var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.left;
		var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.top;

		var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.width;
		var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.height;

		var w = 0.8 * width;
		var h = 0.8 * height;

		var left = ((width / 2) - (w / 2)) + dualScreenLeft;
		var top = ((height / 2) - (h / 2)) + dualScreenTop;

		const url = `${DATA_SOURCE_AUTH_BASE_URL}/${sourceId}/authenticate?access_token=` + AuthService.getAccessToken();

		window.onDataSourceAuthSuccess = function (dataSource) {
			//Remove the success listener
			window.onDataSourceAuthSuccess = null;
			if (dataSource.status === 'Success')
				fetchDataSource(true);

		};

		var newWindow = window.open(url, `Authorize ${sourceId} Account`, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);


		// Puts focus on the newWindow
		if (window.focus) {
			newWindow.focus();
		}

		return false;
	}

}

DataSourceService.instance = new DataSourceService();